import { render, staticRenderFns } from "./BooleanInput.vue?vue&type=template&id=66ba4bf0&scoped=true"
import script from "./BooleanInput.vue?vue&type=script&lang=ts"
export * from "./BooleanInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba4bf0",
  null
  
)

export default component.exports